var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('question',{attrs:{"text":_vm.$t(_vm.item.text)}}),_c('dropdown',{attrs:{"title":"Please select...","options":_vm.options},on:{"select":_vm.handleSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }